<div class="container">

    <div class="col-md-12 lease_table ">
        <div>
            <div class="migration_detials">Student Migration Form</div>
            <div class="col-md-12">
                <div class="">
                    <form [formGroup]="migrationForm">
                        <div class="row mt-3">
                            <div class="col-md-5 d-flex align-items-center">
                              <label for="academicYear" class="me-2 migration_detials2" style="white-space: nowrap;">Academic Year:</label>
                              <select id="academicYear" #inputField  class="form-select w-auto" formControlName="academicYear">
                                <option value="currentyear">Current Year</option>
                                <option value="beforecurrentyear">Before Current Year</option>
                              </select>
                            </div>
                          
                            <div class="col-md-7 d-flex align-items-center">
                              <label for="organizationSelect" class="me-2 migration_detials2" style="white-space: nowrap;">Organization Name:</label>
                              <select id="organizationSelect"  #inputField1 class="form-select w-75" formControlName="organizationId">
                                <option value="" disabled selected>Selected Organization Name</option>
                                <option *ngFor="let org of organizationnames" [value]="org.orgId">
                                  {{ org.orgName }}
                                </option>
                              </select>
                            </div>
                          </div>
                          
                    </form>
                </div>
                <h2 class="migration_detials1">Student Search</h2>
                <div class="position-relative ">
                    <input type="text" class="form-control misinput_control pe-5" placeholder="Search By Admission No"
                        [(ngModel)]="searchCriteria" (keydown)="onKeydown($event)" (keydown)="onKeydown($event)"
                        (input)="filterSearchData()" />


                    <i class="fa fa-search position-absolute top-50 translate-middle-y end-0 me-3" (click)="search()"
                        style="cursor: pointer;"></i>
                    <ul *ngIf="searchdata?.length > 0" class="dropdown-list" (scroll)="onScroll($event)">
                        <li *ngFor="let item of searchdata" (click)="selectItem(item)">
                            {{ item.name }} ({{ item.admNo }})
                        </li>
                    </ul>
                </div>
                <div class="row m-2 col-md-12">
                    <div class=" RecentSearch">
                        <!-- <div class="recent_data">
                    Recent Search
                </div> -->
                        <div>
                            <!-- <ul>
                        <li *ngIf="list" class="box_icon" (click)="changetype()">
                            <img src="../../../../../assets/images/list.svg" alt="">
                        </li>
                        <li *ngIf="!list" class="box_icon" (click)="changetype()">
                            <img src="../../../../../assets/images/boxes.svg" alt="">
                        </li>
                    </ul> -->
                        </div>
                    </div>


                    <div class="table_width">
                        <!-- <ag-grid-angular style="width: 100%; height: 700px; cursor: pointer;" class="ag-theme-alpine"
                    [rowData]="resentsearchlist" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
                    rowSelection="single" (rowClicked)="studentsearch($event.data)">
                </ag-grid-angular> -->
                    </div>

                </div>

            </div>
        </div>
        <div>
            <div *ngIf="listdata">

                <div class=" col-md-12 student_tab">
                    <div>
                        <div>
                            <div class="row">
                                <ul class="list-unstyled col-md-4">
                                    <li class="d-flex  py-2">
                                        <span class="fw-medium col-5">CourseTrack</span>
                                        <span class="course_name col-7">{{courseTrack}}</span>
                                    </li>
                                    <li class="d-flex  py-2">
                                        <span class="fw-medium  col-5">Adm No</span>
                                        <span class="student_name col-7">{{ searchkey }}</span>
                                    </li>

                                    <li class="d-flex  py-2">
                                        <span class="fw-medium  col-5">Name</span>
                                        <span class="student_name col-7">{{ name }}</span>
                                    </li>

                                </ul>
                                <ul class="list-unstyled col-md-4">
                                    <li class="d-flex  py-2">
                                        <span class="fw-medium  col-5">Parent Name</span>
                                        <span class="student_name col-7">{{ parentname}}</span>
                                    </li>
                                    <li class="d-flex  py-2">
                                        <span class="fw-medium  col-5">StudentType</span>
                                        <span class="student_name col-7">{{ studentType
                                            }}</span>
                                    </li>

                                    <li class="d-flex  py-2">
                                        <span class="fw-medium  col-5">Status</span>
                                        <span class="student_name col-7">{{ status}}</span>
                                    </li>
                                </ul>

                                <ul class="list-unstyled col-md-4">

                                    <li class="d-flex  py-2">
                                        <span class="fw-medium col-5">CampusName</span>
                                        <span class="student_name col-7">{{ campusName
                                            }}</span>
                                    </li>
                                </ul>

                                <div class="col-lg-12 text-center">
                                    <button type="button" class="cctv_notebtn" (click)="savestudent()">Submit</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>